module.exports = "/_next/static/images/e9459ea3e24c3cb25d76225d6f3b05ed-mgm-10-million-mobile.jpg";